import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hide",
  "use": "icon-hide-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hide\"><path d=\"M63.854 383.79H576.27v64.044H63.854zM63.542 767.802h513.041v63.919H63.542zM64.012 191.784h512.099v63.978H64.012zM63.913 576.046h512.298v63.919H63.913zM639.902 832.078l320.074-319.855-320.074-319.855z\" p-id=\"15979\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hide.svg
// module id = Elsj
// module chunks = 9